var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Pie',{staticClass:"px-10",attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"width":180,"height":130}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }